import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashboardServiceService } from '../../services/dashboard-service.service';
import { GlobalService } from '../../../../services/global.service';

@Component({
  selector: 'app-end-subscription',
  templateUrl: './end-subscription.component.html',
  styleUrls: ['./end-subscription.component.css'],
})
export class EndSubscriptionComponent implements OnInit {
  status: any;
  unSubMaps: any;
  unSubscribeArray: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dashboardService: DashboardServiceService,
    private global: GlobalService
  ) {
    //modal to end subscribe map subscription
  }

  ngOnInit(): void {
    this.status = this.data.message;
    this.unSubMaps = this.data.maps;
    this.unSubscribeArray = this.data.id;
  }

  noActionDIalog(): void {
    this.dialog.closeAll();
  }

  //unsubscribe my maps
  unSubscribe(): void {
    this.dialog.closeAll();
    this.global.toggleLoader(true);
    this.dashboardService
      .unsubMaps({ map_ids: this.unSubscribeArray })
      .subscribe(() => {
        this.dashboardService.clear(true);
      });
  }
}
